<template>
  <div>
    <Loading v-if="loading" />
    <div v-else class="p-box">
      <div class="p-box__body">
        <Info>
          {{ $t("pages.companies.management.searchPatterns.info") }}
        </Info>

        <div class="p-table__content">
          <table class="searchPatternTable">
            <thead>
              <tr>
                <th>
                  <span>{{ $t("models.searchPattern.name") }}</span>
                </th>
                <th>
                  <button
                    class="p-table__content__sort"
                    :class="orderCss('createdAt')"
                    @click="sortTables('createdAt')"
                  >
                    {{ $t("models.searchPattern.createdAt") }}
                  </button>
                </th>
                <th>
                  <span>{{ $t("models.searchPattern.frequency") }}</span>
                </th>
                <th>
                  <button
                    class="p-table__content__sort"
                    :class="orderCss('receiver')"
                    @click="sortTables('receiver')"
                  >
                    {{ $t("models.searchPattern.receiver") }}
                  </button>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr v-for="searchPattern in items" :key="searchPattern.notificationConfig.searchPatternId">
                <td class="u-fwB">{{ searchPattern.name }}</td>
                <td>{{ basicDateFormat(searchPattern.notificationConfig.createdAt) }}</td>
                <td>{{ getReceiveFrequency(searchPattern.notificationConfig) }}</td>
                <td>
                  <button class="openReceiver" @click="openReceiverModal(searchPattern.notificationConfig)">
                    {{ searchPattern.notificationConfig.userCompanyIds ? searchPattern.notificationConfig.userCompanyIds.length : 0 }}人
                  </button>
                </td>
                <td class="actionContainer">
                  <div>
                    <router-link :to="{ name: 'CompaniesManagementSearchPatternsEdit', params: { company_uuid: currentCompanyUuid, search_pattern_id: searchPattern.notificationConfig.searchPatternId }}" class="action">
                      <Icon name="iconPencil" class="action__icon" />
                      {{ $t('labels.edit') }}
                    </router-link>
                    <a class="action" @click="handleDelete(searchPattern.notificationConfig.searchPatternId)">
                      <Icon name="iconCross" class="action__icon" />
                      {{ $t('labels.delete') }}
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <KkModal :is-visible="isVisibleReceiver" @change="isVisibleReceiver = !isVisibleReceiver">
        <div class="p-modal__content__header">
          {{ $t('pages.companies.management.searchPatterns.modal.title') }}
        </div>
        <div class="p-modal__content__body">
          <template v-for="user in selectedSearchPatternReceiver" :key="user.id">
            <div class="users">
              <div class="users__container">{{ user.name }}</div>
              <div class="users__container--email">{{ user.email }}</div>
              <div class="users__contiainer">{{ $t(`labels.roles.${ user.role }`) }}({{ storeCountLabel(user) }})</div>
            </div>
          </template>
        </div>
        <div class="p-modal__content__footer">
          <div class="c-button c-button--right">
            <div class="js-close" />
            <button
              class="c-button__item c-button__item--outline-cancel"
              @click="isVisibleReceiver = false"
              v-text="$t('labels.close')"
            />
          </div>
        </div>
      </KkModal>
    </div>
  </div>
</template>

<script>
import { basicDateFormat } from '../../../modules/date'
import {mapState, mapActions} from 'vuex'
import Info from '../../../components/Info'
import Loading from '../../../components/Loading'
import Icon from '../../../components/Icon'
import { emailNotificationConfigs } from '../../../modules/emailNotificationConfigConst'
import { dayOfWeek } from '../../../modules/dayOfWeekConst'
import { KkModal } from '../../../components/base'

export default {
  name: 'CompaniesManagementSearchPatterns',
  components: {
    Info,
    Loading,
    Icon,
    KkModal
  },
  data() {
    return {
      sortKey: '',
      sortOrder: '',
      isVisibleReceiver: false,
      selectedSearchPatternReceiver: [],
    }
  },
  computed: {
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    ...mapState({
      searchPatternsLoading: state => state.companiesSearchPatterns.loading,
      searchPatterns: state => state.companiesSearchPatterns.data,
      userCompanies: state => state.companiesUserCompany.data,
      userCompaniesLoading: state => state.companiesUserCompany.loading,
    }),
    loading() {
      return this.searchPatternsLoading || this.userCompaniesLoading
    },
    items() {
      let items = this.searchPatterns.slice()

      if(this.sortKey === 'createdAt') {
        switch (this.sortOrder) {
        case 'asc':
          items = items.sort((a, b) => {
            if (a.notificationConfig[this.sortKey] < b.notificationConfig[this.sortKey]) return -1
            if (a.notificationConfig[this.sortKey] > b.notificationConfig[this.sortKey]) return 1
            return 0
          })
          break
        case 'desc':
          items = items.sort((a, b) => {
            if (a.notificationConfig[this.sortKey] > b.notificationConfig[this.sortKey]) return -1
            if (a.notificationConfig[this.sortKey] < b.notificationConfig[this.sortKey]) return 1
            return 0
          })
          break
        }
      }

      if(this.sortKey === 'receiver') {
        switch (this.sortOrder) {
        case 'asc':
          items = items.sort((a, b) => {
            if (a.notificationConfig.userCompanyIds.length < b.notificationConfig.userCompanyIds.length) return -1
            if (a.notificationConfig.userCompanyIds.length > b.notificationConfig.userCompanyIds.length) return 1
            return 0
          })
          break
        case 'desc':
          items = items.sort((a, b) => {
            if (a.notificationConfig.userCompanyIds.length > b.notificationConfig.userCompanyIds.length) return -1
            if (a.notificationConfig.userCompanyIds.length < b.notificationConfig.userCompanyIds.length) return 1
            return 0
          })
          break
        }
      }

      return items
    },
  },
  created() {
    this.readSearchPatterns()
    this.readUserCompanies()
  },
  methods: {
    ...mapActions({
      readSearchPatterns: 'companiesSearchPatterns/readSearchPatterns',
      deleteSearchPattern: 'companiesSearchPatterns/deleteSearchPattern',
      readUserCompanies: 'companiesUserCompany/readUserCompanies',
    }),
    openReceiverModal(notificationConfig) {
      this.isVisibleReceiver = true
      this.selectedSearchPatternReceiver = this.userCompanies.filter((user) => notificationConfig.userCompanyIds.includes(user.id))
    },
    orderCss(key) {
      if (!this.sortOrder) return '' // 初期値の場合は CSS なし
      if (this.sortKey === key) { // 一致する key の場合に CSS がつく
        return this.sortOrder === 'asc' ? 'is-asc' : 'is-desc'
      } else { // それ以外の key の場合は CSS なし
        return ''
      }
    },
    sortTables(sortKey) {
      if (this.sortKey === sortKey) { // key が一致する場合は2回目押下時
        this.sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc'
      } else { // それ以外の場合は key 1回目押下時
        this.sortKey = sortKey
        this.sortOrder = 'desc'
      }
    },
    basicDateFormat(date) {
      return basicDateFormat(date)
    },
    getReceiveFrequency(notificationConfig) {
      if(notificationConfig.wday){
        return `${emailNotificationConfigs['weekly']}（${dayOfWeek[notificationConfig.wday]}）`
      }

      if(notificationConfig.day) {
        return `${emailNotificationConfigs['monthly']}（${notificationConfig.day}日）`
      }

      return emailNotificationConfigs['daily']
    },
    async handleDelete(id) {
      if (confirm(this.$t('pages.companies.management.searchPatterns.deleteConfirm'))) {
        await this.deleteSearchPattern(id)
        await this.readSearchPatterns()
      }
    },
    storeCountLabel(user) {
      return user.readableAllStore ? this.$t('labels.allStores') : this.$t('labels.simpleStoresCount', { count: user.stores.length } )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../stylesheets/biz_spa/foundation/_var.scss';

.actionContainer{
  width: 15%;
}
.action {
  display: flex;
  align-items: flex-start;
  margin-right: 24px;
  font-size: 12px;
  text-decoration: none;
  cursor: pointer;
  &:not(:first-child) {
    margin-top: 12px;
  }
  &__icon {
    width: 18px;
    margin-right: 8px;
    img {
      display: block;
      width: 100%;
    }
  }
}
.searchPatternTable {
  border-spacing: 0 8px;

  td {
    border-bottom: 1px solid $color-base-c;
  }
}
.openReceiver {
  text-decoration: underline;
}
.users {
  display: flex;
  padding: 12px;
  background: #ECEDF0;
  margin-top: 12px;

  &__container {
    width: 25%;
    margin-right: 5px;
    white-space: pre-wrap;
    overflow-wrap: break-word;

    &--email {
      width: 50%;
      margin-right: 5px;
      white-space: pre-wrap;
      overflow-wrap: break-word;
    }
  }
}
.p-table__content tbody th:not(:first-child), .p-table__content tbody td:not(:first-child) {
  border-left: none;
}
</style>
